import * as Types from '../constants/Types';

export const getListPosts = (filters) => ({ type: Types.POST_LIST_ACTION, filters });
export const setListPosts = (data) => ({ type: Types.POST_LIST_SUCCESS, posts: data.posts, pageIndex: data.pageIndex, pageSize: data.pageSize, totalCount: data.totalCount });

export const getPostDetail = (id) => ({ type: Types.POST_DETAIL_ACTION, id });
export const setPostDetail = (post) => ({ type: Types.POST_DETAIL_SUCCESS, post });
export const updatePostDetail = (post) => ({ type: Types.POST_DETAIL_UPDATE_ACTION, post });
export const createPostDetail = (post) => ({ type: Types.POST_DETAIL_CREATE_ACTION, post });
export const deletePostDetail = (post, filters) => ({ type: Types.POST_DETAIL_DELETE_ACTION, post, filters });

export const createPostTranslate = (post) => ({type: Types.POST_CREATE_TRANSLATE_ACTION, post});
export const updatePostTranslate = (post) => ({type: Types.POST_UPDATE_TRANSLATE_ACTION, post});
export const deletePostTranslate = (post, refreshParams) => ({type: Types.POST_DELETE_TRANSLATE_ACTION, post, refreshParams});
